const BASE_URL = 'https://files.nachonacho.com'

const images = {
  LOGO_NN: `${BASE_URL}/sites/oauth/logo/nachonacho-full-blue-horizontal.svg`,
  LOGO_NN_SELLER: `${BASE_URL}/sites/oauth/logo/nachonacho-seller.svg`,
  LOGO_NN_TRIBE: `${BASE_URL}/sites/oauth/logo/nachonacho-tribe.svg`,
  LOGO_NN_WHITE: `${BASE_URL}/sites/oauth/nachonacho-logotype.svg`,
  LOGO_NN_BLUE: `${BASE_URL}/sites/oauth/sign-up/nachonacho-logotype-blue.svg`,

  GOOGLE_BUTTON_LOGO: `${BASE_URL}/sites/oauth/google-square.svg`,
  LINKEDIN_BUTTON_LOGO: `${BASE_URL}/sites/oauth/linkedin-icon.svg`,
  SLACK_BUTTON_LOGO: `${BASE_URL}/sites/oauth/Slack-square.svg`,
  PASSKEY_LOGO: `${BASE_URL}/sites/oauth/passkey.svg`,
  PASSKEY_BUTTON_LOGO: `${BASE_URL}/sites/app/integrations/passkey-password-svgrepo-com.svg`,

  GOOGLE_PAGE_LOGO: `${BASE_URL}/sites/oauth/google-logo.png`,
  LINKEDIN_PAGE_LOGO: `${BASE_URL}/sites/oauth/Linkedin-Logo.png`,
  SLACK_PAGE_LOGO: `${BASE_URL}/sites/oauth/Slack_RGB.svg`,

  SPINNING_LOGO: `${BASE_URL}/sites/oauth/spinning-logo-newest.svg`,
  LOGO_SYMBOL_BLUE_BACKGROUND: `${BASE_URL}/brand/kit-assets/logo/logo_symbol_blue_background.svg`,

  signUp: {
    CONTROL: `${BASE_URL}/sites/oauth/sign-up/controlSubscriptions.svg`,
    // CONTROL: `${BASE_URL}/sites/oauth/sign-up/control.png`,
    // LIFETIME_DISCOUNTS: `${BASE_URL}/sites/oauth/sign-up/lifetime-discounts.png`,
    LIFETIME_DISCOUNTS: `${BASE_URL}/sites/oauth/sign-up/exclusivePerks.svg`,
    // DISCOVER: `${BASE_URL}/sites/oauth/sign-up/discover.png`,
    // DISCOVER: `${BASE_URL}/sites/oauth/sign-up/discoverBestSaasProducts.svg`,
    DISCOVER: `${BASE_URL}/sites/oauth/sign-up/discoverSaasProducts.svg`,
    // DISCOVER: `${BASE_URL}/sites/oauth/sign-up/discoverBestInClassSaasProducts.svg`,
    DISCOUNTS: `${BASE_URL}/sites/oauth/sign-up/Discounts.svg`,
    EQUAL_OPPORTUNITY: `${BASE_URL}/sites/oauth/sign-up/EqualOpportunity.svg`,
    NO_APPLICATION_REQUIRED: `${BASE_URL}/sites/oauth/sign-up/NoApplicationRequired.svg`,
    ONE_STOP_SHOP: `${BASE_URL}/sites/oauth/sign-up/OneStopShop.svg`,
    PUZZLE_PIECES: `${BASE_URL}/sites/oauth/sign-up/PuzzlePieces.svg`,
    SERVICE_PROVIDERS: `${BASE_URL}/sites/oauth/sign-up/ServiceProviders.svg`,
  },

  signUpSeller: {
    PLUGIN: `${BASE_URL}/sites/auth-frontend/plugin.svg`,
    PROMOTION: `${BASE_URL}/sites/auth-frontend/promotion.svg`,
    ACQUISITION_CHANNEL: `${BASE_URL}/sites/auth-frontend/acquisition-channel.svg`,
  },
  signUpTribe: {
    A: `${BASE_URL}/sites/home/tribes/CoBrand.svg`,
    B: `https://nachonacho.com/home/YourPerks.svg`,
    C: `https://nachonacho.com/home/Dashboard.svg`,
  },

  LINKEDIN_SQUARE_LOGO: `${BASE_URL}/sites/auth-frontend/logos/linkedin_square.svg`,
  SLACK_SQUARE_LOGO: `${BASE_URL}/sites/auth-frontend/logos/slack_square.svg`,

  SIGN_UP_PRODUCT: `${BASE_URL}/sites/auth-frontend/signup-product.png`,
}

export default images
